<script>
import { Line } from 'vue-chartjs'

export default {
  extends: Line,
  props: ['data', 'labels', 'height'],
  methods: {
    montarGrafico () {
      this.renderChart({
        labels: this.labels,
        datasets: this.data
      }, {
        maintainAspectRatio: false,
        legend: {
          display: false
        },
        scales: {
          xAxes: [{
            display: false
          }],
          yAxes: [{
            display: false
          }]
        },
        elements: {
          line: {
            borderWidth: 1
          },
          point: {
            radius: 4,
            hitRadius: 10,
            hoverRadius: 4
          }
        }
      })
    }
  },
  watch: {
    'labels': function () {
      this.montarGrafico()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/dashboard/CardLine3ChartExample.vue